import React from 'react';
import CondensedOrderSummary from './condensed_order_summary';
import ApplePayButton from './apple_pay_button';
import { useApplePay } from './apple_pay_hook';
import { core_apimessages_CartItemAttributes as CartItemAttributes } from '../schemas/rql';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { inMobileBrowser } from '@reverbdotcom/commons/src/user_context_helpers';

interface HoistedApplePayButtonProps {
  listingCurrencyCode: string;
  paymentMethodsConfig: string;
  payButtonType?: 'checkout' | 'plain';
  cartItemAttributes?: CartItemAttributes[];
}

interface Props {
  itemPlusShippingSubtotal: string;
  hoistedApplePayButtonProps: HoistedApplePayButtonProps;
}

function HoistedApplePayWrapper(props: Props) {
  const { paymentMethodsConfig, listingCurrencyCode, cartItemAttributes, payButtonType } = props.hoistedApplePayButtonProps;

  const { isAvailable } = useApplePay({
    paymentMethodsConfig,
    listingCurrencyCode,
  });

  const mParticleViewData = {
    componentName: 'HoistedApplePayWrapper',
    eventName: MParticleEventName.ComponentView,
  };

  useViewTracking(
    mParticleViewData,
    isAvailable,
  );

  const user = useUser();
  const showHoistedApplePayWrapper = isAvailable && inMobileBrowser(user);

  if (!showHoistedApplePayWrapper) {
    return null;
  }

  return (
    <div className="checkout-cart-header">
      <CondensedOrderSummary
        itemPlusShippingSubtotal={props.itemPlusShippingSubtotal}
      />
      <div className="checkout-cart-header__button">
        <div className="checkout-cart-header__button--apple-pay">
          <ApplePayButton
            paymentMethodsConfig={paymentMethodsConfig}
            listingCurrencyCode={listingCurrencyCode}
            cartItemAttributes={cartItemAttributes}
            payButtonType={payButtonType}
          />
        </div>
      </div>
    </div>
  );
}

export default HoistedApplePayWrapper;
